export default {
  SET_COUNTRY_CODE (state, data) {
    state.countryCode = data.countryCode
  }
}



// WEBPACK FOOTER //
// ./src/modules/geolocation/store/mutations.js